<template>
  <!-- begin sidebar nav -->
  <ul class="nav" v-if="menus">
    <!-- <li class="nav-header">Navigation</li> -->
    <template v-for="menu in menus">
      <sidebar-nav-list
        ref="sidebarNavList"
        v-bind:menu="menu"
        v-bind:scrollTop="scrollTop"
        v-bind:key="menu.path"
        v-bind:status="menu.status"
        v-on:collapse-other="handleCollapseOther(menu)"
      ></sidebar-nav-list>
    </template>
    <!-- begin sidebar minify button -->
    <li>
      <a
        href="javascript:;"
        class="sidebar-minify-btn"
        v-on:click="handleSidebarMinify()"
      >
        <i class="fa fa-angle-double-left"></i>
      </a>
    </li>
    <!-- end sidebar minify button -->
  </ul>
  <!-- end sidebar nav -->
</template>

<script>
import navigations from '@/config/navigations'
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'SidebarNav',
  props: ['scrollTop'],
  components: {
    SidebarNavList
  },
  data() {
    return {
      pageOptions: PageOptions
    }
  },
  computed: {
    menus() {
      return this.getAllowedNavItems(navigations)
    }
  },
  methods: {
    getAllowedNavItems(navItems) {
      // let _allowNavItems = []

      // for (let nav of navItems) {
      //   if (nav.children && nav.children.length > 0) {
      //     let _children = this.getAllowedNavItems(nav.children)

      //     if (_children.length > 0) {
      //       _allowNavItems.push({
      //         ...nav,
      //         children: _children
      //       })
      //     }
      //   }

      //   if (
      //     this.$store.state.authUser.permissions.includes(nav.permission) &&
      //     nav.allowedUserType === this.$store.getters.userType
      //   ) {
      //     _allowNavItems.push(nav)
      //   }
      // }

      // return _allowNavItems

      return navItems
    },
    handleCollapseOther: function(menu) {
      for (var i = 0; i < this.menus.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu)
      }
    },
    handleSidebarMinify: function() {
      this.pageOptions.pageSidebarMinified = !this.pageOptions
        .pageSidebarMinified
    }
  }
}
</script>
